export default {
  auth: () => import("/webapps/journalistic-pwa/frontend/layouts/auth.vue"),
  blank: () => import("/webapps/journalistic-pwa/frontend/layouts/blank.vue"),
  default: () => import("/webapps/journalistic-pwa/frontend/layouts/default.vue")
}